/* Camisas do Mundo — JS mínimo, sem dependências.
   Foco: revelar seções no scroll, PDP option toggling, caixa-tier select. */

(function () {
  'use strict';

  // ---------- Reveal on scroll ----------
  const reveals = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }

  // ---------- PDP option pills ----------
  document.querySelectorAll('[data-option-group]').forEach((group) => {
    const pills = group.querySelectorAll('.option-pill');
    pills.forEach((p) => {
      p.addEventListener('click', () => {
        pills.forEach((x) => x.classList.remove('is-active'));
        p.classList.add('is-active');
        const input = group.querySelector('input[type="hidden"]');
        if (input) input.value = p.dataset.value;
      });
    });
  });

  // ---------- Caixa tier select ----------
  document.querySelectorAll('[data-caixa-tiers]').forEach((wrap) => {
    const tiers = wrap.querySelectorAll('.caixa-tier');
    tiers.forEach((t) => {
      t.addEventListener('click', () => {
        tiers.forEach((x) => x.classList.remove('is-active'));
        t.classList.add('is-active');
      });
    });
  });

  // ---------- Cart count refresh ----------
  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const data = await res.json();
      const el = document.querySelector('[data-cart-count]');
      if (el) {
        el.textContent = data.item_count > 0 ? data.item_count : '';
        el.style.display = data.item_count > 0 ? 'inline-flex' : 'none';
      }
    } catch (_) {}
  }
  refreshCart();
  document.addEventListener('cart:updated', refreshCart);

  // ---------- Add to cart (PDP) ----------
  const form = document.querySelector('[data-product-form]');
  if (form) {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[data-add-to-cart]');
      if (btn) {
        btn.disabled = true;
        btn.dataset.originalText = btn.textContent;
        btn.textContent = 'Adicionando…';
      }
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
          body: new URLSearchParams(new FormData(form))
        });
        if (!res.ok) throw new Error('cart add failed');
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (btn) { btn.textContent = 'Adicionado ✓'; setTimeout(() => { btn.textContent = btn.dataset.originalText; btn.disabled = false; }, 1600); }
      } catch (err) {
        if (btn) { btn.textContent = 'Erro — tente novamente'; btn.disabled = false; }
      }
    });
  }

  // ---------- Mobile menu toggle ----------
  const toggle = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // ---------- Hero slideshow ----------
  document.querySelectorAll('[data-hero-slideshow]').forEach((slideshow) => {
    const slides = slideshow.querySelectorAll('.hero-slide');
    if (slides.length === 0) return;
    const dots = slideshow.querySelectorAll('[data-slide-goto]');
    const prev = slideshow.querySelector('[data-slide-prev]');
    const next = slideshow.querySelector('[data-slide-next]');
    const autoplay = slideshow.dataset.autoplay === 'true';
    const interval = Math.max(3, parseInt(slideshow.dataset.interval || '6', 10)) * 1000;

    let current = 0;
    let timer = null;

    function go(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach((s, idx) => s.classList.toggle('is-active', idx === current));
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === current));
    }
    function start() {
      if (!autoplay || slides.length < 2) return;
      stop();
      timer = setInterval(() => go(current + 1), interval);
    }
    function stop() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    // Init: ensure first slide active
    slides.forEach((s, idx) => s.classList.toggle('is-active', idx === 0));
    if (dots.length) dots.forEach((d, idx) => d.classList.toggle('is-active', idx === 0));

    if (prev) prev.addEventListener('click', () => { go(current - 1); start(); });
    if (next) next.addEventListener('click', () => { go(current + 1); start(); });
    dots.forEach((d) => {
      d.addEventListener('click', () => { go(parseInt(d.dataset.slideGoto, 10) || 0); start(); });
    });

    slideshow.addEventListener('mouseenter', stop);
    slideshow.addEventListener('mouseleave', start);

    // Pause when off-screen
    if ('IntersectionObserver' in window) {
      const io2 = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) start(); else stop(); });
      }, { threshold: 0.25 });
      io2.observe(slideshow);
    } else {
      start();
    }
  });


  // ---------- Filter toggle (single-axis: Selecao Brasileira) ----------
  document.querySelectorAll('[data-filter-section]').forEach((section) => {
    const grid = section.querySelector('[data-filter-grid]');
    if (!grid) return;
    const mode = grid.dataset.filterMode || 'single';
    const cards = Array.from(grid.querySelectorAll('.product-card'));

    if (mode === 'single') {
      const previewLimit = grid.dataset.previewLimit ? parseInt(grid.dataset.previewLimit) : null;
      const tagOrder = { atual: 0, retro: 1, feminino: 2, infantil: 3, especial: 4 };

      function applyFilter(filter) {
        if (filter === 'all') {
          const sorted = [...cards].sort((a, b) => {
            const pa = tagOrder[a.dataset.filterTag] ?? 2;
            const pb = tagOrder[b.dataset.filterTag] ?? 2;
            return pa - pb;
          });
          sorted.forEach((card, i) => {
            card.style.order = i;
            card.hidden = previewLimit ? i >= previewLimit : false;
          });
        } else {
          let shown = 0;
          cards.forEach((card) => {
            card.style.removeProperty('order');
            const matches = card.dataset.filterTag === filter;
            if (matches && previewLimit) {
              shown++;
              card.hidden = shown > previewLimit;
            } else {
              card.hidden = !matches;
            }
          });
        }
      }

      // Apply preview limit on initial load
      applyFilter('all');

      const pills = section.querySelectorAll('[data-filter]');
      pills.forEach((pill) => {
        pill.addEventListener('click', () => {
          const filter = pill.dataset.filter;
          pills.forEach((p) => p.classList.toggle('is-active', p === pill));
          applyFilter(filter);
        });
      });
    } else if (mode === 'dual') {
      // Dual-axis: primary (selecao/clube) + secondary (league)
      const primaryPills = section.querySelectorAll('[data-primary]');
      const secondaryWrap = section.querySelector('[data-filter-toggle-sub]');
      const secondaryPills = section.querySelectorAll('[data-secondary]');
      let currentPrimary = 'all';
      let currentSecondary = 'all';

      const dualPreviewLimit = grid.dataset.previewLimit ? parseInt(grid.dataset.previewLimit) : null;

      function applyFilter() {
        let shown = 0;
        cards.forEach((card) => {
          const p = card.dataset.filterPrimary;
          const s = card.dataset.filterSecondary;
          const matchP = currentPrimary === 'all' || p === currentPrimary;
          const matchS = currentSecondary === 'all' || s === currentSecondary;
          const matches = matchP && matchS;
          if (matches && dualPreviewLimit) {
            shown++;
            card.hidden = shown > dualPreviewLimit;
          } else {
            card.hidden = !matches;
          }
        });
      }

      primaryPills.forEach((pill) => {
        pill.addEventListener('click', () => {
          currentPrimary = pill.dataset.primary;
          primaryPills.forEach((p) => p.classList.toggle('is-active', p === pill));
          // Show/hide sub-toggle based on Ligas selection
          if (secondaryWrap) {
            secondaryWrap.hidden = currentPrimary !== 'clube';
          }
          // Reset secondary when primary changes
          if (currentPrimary !== 'clube') {
            currentSecondary = 'all';
            secondaryPills.forEach((p) => p.classList.toggle('is-active', p.dataset.secondary === 'all'));
          }
          applyFilter();
        });
      });

      secondaryPills.forEach((pill) => {
        pill.addEventListener('click', () => {
          currentSecondary = pill.dataset.secondary;
          secondaryPills.forEach((p) => p.classList.toggle('is-active', p === pill));
          applyFilter();
        });
      });

      // Apply preview limit on initial load (no-op when no data-preview-limit is set, e.g. Todos page)
      applyFilter();
    }
  });

  // ---------- Caixa Misteriosa 2-slide banner ----------
  document.querySelectorAll('[data-caixa-banner]').forEach((banner) => {
    const slides = banner.querySelectorAll('.caixa-banner__slide');
    if (slides.length < 2) return;
    const dots = banner.querySelectorAll('[data-banner-goto]');
    const prev = banner.querySelector('[data-banner-prev]');
    const next = banner.querySelector('[data-banner-next]');
    const autoplay = banner.dataset.autoplay === 'true';
    const interval = Math.max(4, parseInt(banner.dataset.interval || '7', 10)) * 1000;

    let current = 0;
    let timer = null;

    function go(i) {
      current = (i + slides.length) % slides.length;
      slides.forEach((s, idx) => s.classList.toggle('is-active', idx === current));
      dots.forEach((d, idx) => d.classList.toggle('is-active', idx === current));
    }
    function start() {
      if (!autoplay) return;
      stop();
      timer = setInterval(() => go(current + 1), interval);
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    if (prev) prev.addEventListener('click', () => { go(current - 1); start(); });
    if (next) next.addEventListener('click', () => { go(current + 1); start(); });
    dots.forEach((d) => d.addEventListener('click', () => { go(parseInt(d.dataset.bannerGoto, 10) || 0); start(); }));

    banner.addEventListener('mouseenter', stop);
    banner.addEventListener('mouseleave', start);

    if ('IntersectionObserver' in window) {
      const io3 = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) start(); else stop(); });
      }, { threshold: 0.25 });
      io3.observe(banner);
    } else {
      start();
    }
  });


  

  // ---------- Homepage collection marquee (desktop 2-row loop; mobile single swipe) ----------
  document.querySelectorAll('[data-rail-marquee]').forEach((mq) => {
    const pool = mq.querySelector('[data-marquee-source]');
    const rowTop = mq.querySelector('[data-marquee-row="top"]');
    const rowBottom = mq.querySelector('[data-marquee-row="bottom"]');
    const prevBtn = mq.querySelector('[data-rail-prev]');
    const nextBtn = mq.querySelector('[data-rail-next]');
    if (!pool || !rowTop) return;

    const SPEED = 42;        // px/second auto-loop
    const GAP = 14;
    const PER_ROW = 6;       // desktop: cards that fill one row's width
    const LOOP_MIN = 24;     // ≥24 matching products → continuous opposite-direction loop
    const ARROW_CARDS = 3;
    const reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    const isMobile = () => !!(window.matchMedia && window.matchMedia('(max-width: 760px)').matches);
    let states = [], rafId = null, lastTs = 0, paused = false, offscreen = false;

    const visibleCards = () => Array.from(pool.querySelectorAll('.product-card:not([hidden])'));

    // Size cards so exactly PER_ROW fill the row width (no right-side deadspace) on desktop.
    function setCardWidth() {
      const w = ((mq.clientWidth || 1) - (PER_ROW - 1) * GAP) / PER_ROW;
      mq.style.setProperty('--rail-cw', Math.max(120, Math.floor(w)) + 'px');
    }

    function fill(row, cards, loop) {
      row.innerHTML = '';
      const track = document.createElement('div');
      track.className = 'rail-marquee__track';
      row.appendChild(track);
      const appendSet = () => cards.forEach((c) => {
        const cl = c.cloneNode(true);   // keep the hover image (hovering pauses the row)
        cl.removeAttribute('data-filter-primary');
        cl.removeAttribute('data-filter-secondary');
        cl.removeAttribute('data-filter-tag');
        cl.removeAttribute('hidden');
        cl.style.order = '';
        track.appendChild(cl);
      });
      if (!loop) { appendSet(); row.scrollLeft = 0; return null; }
      let k = 1; appendSet();
      const rowW = row.clientWidth || mq.clientWidth || 1;
      while (track.scrollWidth < rowW && k < 14) { appendSet(); k++; }
      const unit = track.scrollWidth;
      for (let i = 0; i < k; i++) appendSet();   // duplicate the unit → seamless wrap
      return { row, unit };
    }

    function rebuild() {
      const cards = visibleCards();
      states = [];
      if (!cards.length) { mq.style.display = 'none'; updateArrows(); return; }
      mq.style.display = '';
      setCardWidth();
      const n = cards.length;

      // MOBILE: one horizontal swipe row with all products (no 2nd row, no auto-loop).
      if (isMobile()) {
        mq.classList.add('is-single');
        fill(rowTop, cards, false);
        if (rowBottom) rowBottom.innerHTML = '';
        updateArrows();
        return;
      }

      if (n >= LOOP_MIN) {
        // Continuous loop: two rows, disjoint interleaved halves, opposite directions.
        mq.classList.remove('is-single');
        const top = cards.filter((_, i) => i % 2 === 0);
        const bot = cards.filter((_, i) => i % 2 === 1);
        const t = fill(rowTop, top, true);
        if (t) { t.row.scrollLeft = t.unit; states.push({ row: t.row, unit: t.unit, dir: -1 }); }
        if (rowBottom) {
          const b = fill(rowBottom, bot.length ? bot : cards, true);
          if (b) { b.row.scrollLeft = 0; states.push({ row: b.row, unit: b.unit, dir: 1 }); }
        }
      } else if (n <= PER_ROW || !rowBottom) {
        // Fits in one row.
        mq.classList.add('is-single');
        fill(rowTop, cards, false);
        if (rowBottom) rowBottom.innerHTML = '';
      } else {
        // Two static rows: first PER_ROW → top, next PER_ROW → bottom, surplus split equally.
        mq.classList.remove('is-single');
        const topVis = cards.slice(0, PER_ROW);
        const botVis = cards.slice(PER_ROW, PER_ROW * 2);
        const surplus = cards.slice(PER_ROW * 2);
        const half = Math.ceil(surplus.length / 2);
        fill(rowTop, topVis.concat(surplus.slice(0, half)), false);
        fill(rowBottom, botVis.concat(surplus.slice(half)), false);
      }
      updateArrows();
    }

    // One arrow pair drives BOTH rows; shown only when there's hidden content to reveal.
    const rowOverflows = (r) => r && (r.scrollWidth - r.clientWidth > 16);
    function updateArrows() {
      const twoRow = !mq.classList.contains('is-single');
      const show = !isMobile() && (rowOverflows(rowTop) || (twoRow && rowBottom && rowOverflows(rowBottom)));
      if (prevBtn) prevBtn.hidden = !show;
      if (nextBtn) nextBtn.hidden = !show;
    }
    function scrollBoth(dir) {
      const cw = parseFloat(getComputedStyle(mq).getPropertyValue('--rail-cw')) || 180;
      const amt = dir * (cw + GAP) * ARROW_CARDS;
      [rowTop, rowBottom].forEach((r) => { if (r) r.scrollBy({ left: amt, behavior: 'smooth' }); });
    }
    if (prevBtn) prevBtn.addEventListener('click', () => scrollBoth(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => scrollBoth(1));

    function tick(ts) {
      const dt = lastTs ? Math.min(0.05, (ts - lastTs) / 1000) : 0;
      lastTs = ts;
      if (states.length && !paused && !offscreen && !reduce) {
        states.forEach((st) => {
          if (!st.unit) return;
          let p = st.row.scrollLeft + st.dir * SPEED * dt;
          p = ((p % st.unit) + st.unit) % st.unit;   // wrap invisibly (content repeats every unit)
          st.row.scrollLeft = p;
        });
      }
      rafId = requestAnimationFrame(tick);
    }

    mq.addEventListener('mouseenter', () => { paused = true; });
    mq.addEventListener('mouseleave', () => { paused = false; });
    let tt;
    mq.addEventListener('touchstart', () => { paused = true; clearTimeout(tt); tt = setTimeout(() => { paused = false; }, 3000); }, { passive: true });

    let rb; const sched = () => { clearTimeout(rb); rb = setTimeout(rebuild, 80); };
    if ('MutationObserver' in window) new MutationObserver(sched).observe(pool, { attributes: true, attributeFilter: ['hidden'], subtree: true });
    window.addEventListener('resize', sched);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((e) => { offscreen = !e[0].isIntersecting; }, { threshold: 0 }).observe(mq);
    }

    rebuild();
    rafId = requestAnimationFrame(tick);
  });

  // ====================================================================
  // CAIXA MISTERIOSA PDP LOGIC (v2.2)
  // ====================================================================

  // ---------- Caixa options pill state (radio behavior) ----------
  function bindOptionPills(root) {
    root.querySelectorAll('.caixa-option-pill input[type="radio"]').forEach((input) => {
      input.addEventListener('change', () => {
        const name = input.name;
        root.querySelectorAll(`.caixa-option-pill input[name="${CSS.escape(name)}"]`).forEach((sibling) => {
          sibling.closest('.caixa-option-pill').classList.toggle('is-active', sibling === input);
        });
        if (root.dispatchEvent) root.dispatchEvent(new CustomEvent('caixa:recalc'));
      });
    });
  }

  // ---------- Compute total based on option deltas + tree adjustment ----------
  function recalcCaixaPrice(pdp) {
    const base = parseFloat(pdp.dataset.basePrice || '0') || 0;
    let extras = 0;
    pdp.querySelectorAll('input[type="radio"]:checked[data-option-delta]').forEach((input) => {
      extras += parseFloat(input.dataset.optionDelta) || 0;
    });
    const treeAdjInput = pdp.querySelector('[data-tree-adjustment-input]');
    let treeAdj = 0;
    if (treeAdjInput) {
      const m = (treeAdjInput.value || '').match(/-?\d+(?:[\.,]\d+)?/);
      if (m) treeAdj = parseFloat(m[0].replace(',', '.')) || 0;
    }
    const total = base + extras + treeAdj;
    const fmt = (n) => 'R$ ' + n.toFixed(2).replace('.', ',');
    pdp.querySelectorAll('[data-price-total]').forEach((el) => { el.textContent = fmt(total); });
    pdp.querySelectorAll('[data-price-cta]').forEach((el) => { el.textContent = fmt(total); });
  }

  // ---------- Accordion: smart sibling auto-close ----------
  // Siblings at the same level close when one opens; nested children of an open branch stay open.
  function setupAccordion(root) {
    const triggers = root.querySelectorAll('[data-acc-toggle]');
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        // Don't toggle when clicking the checkbox inside
        if (e.target.matches('input[type="checkbox"]')) return;
        const id = trigger.dataset.accToggle;
        const branch = trigger.closest('.tree-acc__branch');
        const panel = branch.querySelector('[data-acc-panel="' + id + '"]');
        const isOpen = branch.classList.contains('is-open');
        if (isOpen) {
          branch.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
          if (panel) panel.style.display = 'none';
        } else {
          // Close siblings at same depth (siblings of `branch`)
          const parentContainer = branch.parentElement;
          if (parentContainer) {
            Array.from(parentContainer.children).forEach((sib) => {
              if (sib !== branch && sib.classList && sib.classList.contains('tree-acc__branch') && sib.classList.contains('is-open')) {
                sib.classList.remove('is-open');
                const sibTrigger = sib.querySelector('[data-acc-toggle]');
                if (sibTrigger) sibTrigger.setAttribute('aria-expanded', 'false');
                const sibPanel = sib.querySelector('[data-acc-panel]');
                if (sibPanel) sibPanel.style.display = 'none';
              }
            });
          }
          branch.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
          if (panel) panel.style.display = '';
        }
      });
    });
    // Hide all panels initially
    root.querySelectorAll('[data-acc-panel]').forEach((p) => { p.style.display = 'none'; });
  }

  // ---------- Tree: render nations + leagues into accordion + compute pricing ----------
  function setupCaixaTree(tree, pdp) {
    if (!window.CDM_DB) return;

    const basePrice = parseFloat(tree.dataset.basePrice || '0') || 0;
    const state = {
      nations: new Set(window.CDM_DB.nations.map((n) => n.code)),
      leagues: new Map() // league code -> Set of included team names
    };
    window.CDM_DB.leagues.forEach((lg) => {
      state.leagues.set(lg.code, new Set(lg.teams));
    });

    // ---- Render Nations grid ----
    const nationsGrid = tree.querySelector('[data-nations-grid]');
    if (nationsGrid) {
      const grouped = {};
      window.CDM_DB.nations.forEach((n) => {
        if (!grouped[n.region]) grouped[n.region] = [];
        grouped[n.region].push(n);
      });
      let html = '';
      Object.keys(grouped).sort().forEach((region) => {
        html += `<div class="tree-region"><h5 class="tree-region__title">${region}</h5><div class="tree-region__items">`;
        grouped[region].forEach((n) => {
          html += `<label class="tree-item"><input type="checkbox" class="tree-checkbox" data-nation-code="${n.code}" checked /><span>${n.name}</span></label>`;
        });
        html += '</div></div>';
      });
      nationsGrid.innerHTML = html;
    }

    // ---- Render Leagues nested accordions ----
    const leaguesList = tree.querySelector('[data-leagues-list]');
    if (leaguesList) {
      let html = '';
      window.CDM_DB.leagues.forEach((lg) => {
        html += `<div class="tree-acc__branch" data-branch-id="liga-${lg.code}" data-league="${lg.code}">
          <button type="button" class="tree-acc__trigger tree-acc__trigger--sub" data-acc-toggle="liga-${lg.code}" aria-expanded="false">
            <span class="tree-acc__caret">▶</span>
            <span class="tree-acc__label">
              <input type="checkbox" class="tree-checkbox" data-league-code="${lg.code}" checked />
              <span class="tree-acc__label-text">${lg.name}</span>
              <span class="tree-acc__country">${lg.country}</span>
            </span>
            <span class="tree-acc__counter" data-league-counter="${lg.code}">— todas</span>
          </button>
          <div class="tree-acc__panel" data-acc-panel="liga-${lg.code}">
            <div class="tree-region__items">`;
        lg.teams.forEach((team) => {
          html += `<label class="tree-item"><input type="checkbox" class="tree-checkbox" data-team-name="${team}" data-team-league="${lg.code}" checked /><span>${team}</span></label>`;
        });
        html += `</div></div></div>`;
      });
      leaguesList.innerHTML = html;
    }

    // Re-init accordion on new content
    setupAccordion(tree.querySelector('[data-acc-root]'));

    // ---- Cascading checkbox logic ----
    function applyCascade(checkbox) {
      const checked = checkbox.checked;
      // Root nodes
      if (checkbox.dataset.treeNode === 'nacoes') {
        tree.querySelectorAll('[data-nation-code]').forEach((cb) => { cb.checked = checked; });
      } else if (checkbox.dataset.treeNode === 'ligas') {
        tree.querySelectorAll('[data-league-code]').forEach((cb) => { cb.checked = checked; });
        tree.querySelectorAll('[data-team-name]').forEach((cb) => { cb.checked = checked; });
      } else if (checkbox.dataset.leagueCode) {
        // league checkbox toggled — set all teams in this league
        const lg = checkbox.dataset.leagueCode;
        tree.querySelectorAll(`[data-team-league="${lg}"]`).forEach((cb) => { cb.checked = checked; });
      } else if (checkbox.dataset.teamName) {
        // team toggled — bubble up
        const lg = checkbox.dataset.teamLeague;
        const peers = tree.querySelectorAll(`[data-team-league="${lg}"]`);
        const allChecked = Array.from(peers).every((cb) => cb.checked);
        const leagueBox = tree.querySelector(`[data-league-code="${lg}"]`);
        if (leagueBox) leagueBox.checked = allChecked;
      } else if (checkbox.dataset.nationCode) {
        // bubble up to nacoes parent
        const allNations = tree.querySelectorAll('[data-nation-code]');
        const allChecked = Array.from(allNations).every((cb) => cb.checked);
        const root = tree.querySelector('[data-tree-node="nacoes"]');
        if (root) root.checked = allChecked;
      }

      // Bubble up: ligas root
      const allLeagues = tree.querySelectorAll('[data-league-code]');
      const allLeaguesChecked = Array.from(allLeagues).every((cb) => cb.checked);
      const ligasRoot = tree.querySelector('[data-tree-node="ligas"]');
      if (ligasRoot) ligasRoot.checked = allLeaguesChecked;

      computePricing();
      updateCounters();
    }

    function updateCounters() {
      // Nations counter
      const nationBoxes = tree.querySelectorAll('[data-nation-code]');
      const nationExcl = Array.from(nationBoxes).filter((cb) => !cb.checked).length;
      const nationCounter = tree.querySelector('[data-counter="nacoes"]');
      if (nationCounter) {
        nationCounter.textContent = nationExcl === 0 ? '— todas incluídas' : `— ${nationExcl} excluída${nationExcl > 1 ? 's' : ''}`;
      }

      // Per-league counters + overall ligas counter
      let leaguesExcl = 0;
      let leaguesPartiallyExcl = 0;
      let clubsTotalExcl = 0;
      window.CDM_DB.leagues.forEach((lg) => {
        const teamBoxes = tree.querySelectorAll(`[data-team-league="${lg.code}"]`);
        const excl = Array.from(teamBoxes).filter((cb) => !cb.checked).length;
        clubsTotalExcl += excl;
        const counter = tree.querySelector(`[data-league-counter="${lg.code}"]`);
        if (counter) {
          if (excl === 0) counter.textContent = '— todos';
          else if (excl === teamBoxes.length) { counter.textContent = '— liga excluída'; leaguesExcl++; }
          else { counter.textContent = `— ${excl} excluído${excl > 1 ? 's' : ''}`; leaguesPartiallyExcl++; }
        }
      });
      const ligasCounter = tree.querySelector('[data-counter="ligas"]');
      if (ligasCounter) {
        if (clubsTotalExcl === 0) ligasCounter.textContent = '— todas incluídas';
        else ligasCounter.textContent = `— ${clubsTotalExcl} clube${clubsTotalExcl > 1 ? 's' : ''} / ${leaguesExcl} liga${leaguesExcl !== 1 ? 's' : ''} excluído${leaguesExcl !== 1 ? 's' : ''}`;
      }
    }

    function computePricing() {
      const exclusions = { ligas_all: false, nacoes_all: false, leagues_excl: [], clubs_excl: [], nations_excl: [] };

      const ligasRoot  = tree.querySelector('[data-tree-node="ligas"]');
      const nacoesRoot = tree.querySelector('[data-tree-node="nacoes"]');
      if (ligasRoot  && !ligasRoot.checked)  exclusions.ligas_all  = true;
      if (nacoesRoot && !nacoesRoot.checked) exclusions.nacoes_all = true;

      if (exclusions.ligas_all) {
        window.CDM_DB.leagues.forEach((lg) => exclusions.leagues_excl.push(lg.code));
      } else {
        window.CDM_DB.leagues.forEach((lg) => {
          const teamBoxes = tree.querySelectorAll(`[data-team-league="${lg.code}"]`);
          const exclTeams = Array.from(teamBoxes).filter((cb) => !cb.checked).map((cb) => cb.dataset.teamName);
          if (exclTeams.length === teamBoxes.length && teamBoxes.length > 0) {
            exclusions.leagues_excl.push(lg.code);
          } else if (exclTeams.length > 0) {
            exclusions.clubs_excl = exclusions.clubs_excl.concat(exclTeams.map((t) => lg.code + ':' + t));
          }
        });
      }

      if (!exclusions.nacoes_all) {
        tree.querySelectorAll('[data-nation-code]').forEach((cb) => {
          if (!cb.checked) exclusions.nations_excl.push(cb.dataset.nationCode);
        });
      }

      // Write readable exclusion line-item properties
      const nationsInput = tree.querySelector('[data-tree-nations-input]');
      const leaguesInput = tree.querySelector('[data-tree-leagues-input]');
      const clubsInput   = tree.querySelector('[data-tree-clubs-input]');

      if (nationsInput) {
        nationsInput.value = exclusions.nacoes_all ? 'TODAS' :
          exclusions.nations_excl.map((code) => {
            const n = window.CDM_DB.nations.find((n) => n.code === code);
            return n ? n.name : code;
          }).join(', ');
      }
      if (leaguesInput) {
        leaguesInput.value = exclusions.ligas_all ? 'TODAS' :
          exclusions.leagues_excl.map((code) => {
            const lg = window.CDM_DB.leagues.find((l) => l.code === code);
            return lg ? lg.name : code;
          }).join(', ');
      }
      if (clubsInput) {
        clubsInput.value = exclusions.clubs_excl.map((c) => c.split(':')[1] || c).join(', ');
      }
    }

    // ---- Removal limits ----
    const LIMITS = { nations: 5, leagues: 7, clubs: 5 };

    function showLimitMsg(msg) {
      let el = tree.querySelector('[data-limit-msg]');
      if (!el) {
        el = document.createElement('p');
        el.dataset.limitMsg = '';
        el.style.cssText = 'color:#f87171;font-size:12px;padding:4px 0 0;margin:0;';
        const head = tree.querySelector('.caixa-tree__head');
        if (head) head.appendChild(el); else tree.prepend(el);
      }
      el.textContent = msg;
      clearTimeout(el._t);
      el._t = setTimeout(() => { el.textContent = ''; }, 3000);
    }

    function checkLimit(cb) {
      if (cb.checked) return true; // checking (re-including) is always allowed
      if (cb.dataset.nationCode) {
        const excl = Array.from(tree.querySelectorAll('[data-nation-code]')).filter((x) => !x.checked).length;
        if (excl > LIMITS.nations) { showLimitMsg(`Limite de ${LIMITS.nations} nações excluídas atingido.`); return false; }
      } else if (cb.dataset.leagueCode) {
        const excl = Array.from(tree.querySelectorAll('[data-league-code]')).filter((x) => !x.checked).length;
        if (excl > LIMITS.leagues) { showLimitMsg(`Limite de ${LIMITS.leagues} ligas excluídas atingido.`); return false; }
      } else if (cb.dataset.teamName) {
        const leagueBox = tree.querySelector(`[data-league-code="${cb.dataset.teamLeague}"]`);
        if (leagueBox && leagueBox.checked) {
          const excl = Array.from(tree.querySelectorAll('[data-team-name]'))
            .filter((x) => !x.checked && tree.querySelector(`[data-league-code="${x.dataset.teamLeague}"]`)?.checked).length;
          if (excl > LIMITS.clubs) { showLimitMsg(`Limite de ${LIMITS.clubs} clubes excluídos atingido.`); return false; }
        }
      }
      return true;
    }

    // ---- Bind change handlers ----
    tree.addEventListener('change', (e) => {
      if (!e.target.matches('input[type="checkbox"]')) return;
      if (!checkLimit(e.target)) {
        e.target.checked = true; // revert
        return;
      }
      applyCascade(e.target);
    });

    // ---- Reset button ----
    const resetBtn = tree.querySelector('[data-tree-reset]');
    if (resetBtn) {
      resetBtn.addEventListener('click', () => {
        tree.querySelectorAll('input[type="checkbox"]').forEach((cb) => { cb.checked = true; });
        computePricing();
        updateCounters();
      });
    }

    // Initial state
    computePricing();
    updateCounters();
  }

  // ---------- Team picker (Caixa do Seu Time) ----------
  function setupTeamPicker(picker) {
    if (!window.CDM_DB) return;
    const select = picker.querySelector('[data-team-select]');
    if (!select) return;

    // Map of optgroup label -> array of options to inject
    const groups = {
      'Seleções': window.CDM_DB.nations.map((n) => n.name).sort(),
    };
    window.CDM_DB.leagues.forEach((lg) => {
      const label = lg.name + (lg.country && !lg.name.includes(lg.country) ? ` (${lg.country})` : '');
      groups[label] = lg.teams.slice().sort();
    });

    Array.from(select.querySelectorAll('optgroup')).forEach((og) => {
      const label = og.label;
      const teams = groups[label] || [];
      teams.forEach((t) => {
        const opt = document.createElement('option');
        opt.value = t;
        opt.textContent = t;
        og.appendChild(opt);
      });
    });

    // Change button
    const changeBtn = picker.querySelector('[data-team-change]');
    if (changeBtn) {
      changeBtn.addEventListener('click', () => {
        const sel = picker.querySelector('[data-team-selector]');
        const saved = picker.querySelector('[data-saved-team]');
        if (sel) sel.hidden = false;
        if (saved) saved.hidden = true;
      });
    }
  }

  // ---------- Init all caixa PDPs ----------
  document.querySelectorAll('[data-caixa-pdp]').forEach((pdp) => {
    // Load variant data scoped to this section element
    const variantsEl = pdp.querySelector('script[data-caixa-variants]');
    const variants   = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    const variantMap = new Map();
    variants.forEach((v) => {
      const key = [v.option1, v.option2, v.option3].filter(Boolean).join('::');
      variantMap.set(key, { id: v.id, price: Math.round(Number(v.price)) }); // Liquid price is already in cents
    });

    // Sync pill delta labels with actual variant prices so display never drifts from checkout
    function updatePillDeltasFromVariants() {
      if (!variantMap.size) return;
      const neutralEraInput = pdp.querySelector('input[data-option-axis="era"][data-option-delta="0"]');
      const neutralEra      = neutralEraInput ? neutralEraInput.value : null;
      const baseParts       = ['Apenas sem', 'Apenas sem'];
      if (neutralEra) baseParts.push(neutralEra);
      const baseVariant = variantMap.get(baseParts.join('::'));
      if (!baseVariant) return;
      const basePrice = baseVariant.price; // cents

      pdp.querySelectorAll('input[type="radio"][data-option-axis]').forEach((input) => {
        const axis = input.dataset.optionAxis;
        const val  = input.value;
        let parts;
        if      (axis === 'custom') parts = [val, 'Apenas sem', ...(neutralEra ? [neutralEra] : [])];
        else if (axis === 'patch')  parts = ['Apenas sem', val,  ...(neutralEra ? [neutralEra] : [])];
        else if (axis === 'era')    parts = ['Apenas sem', 'Apenas sem', val];
        if (!parts) return;
        const v = variantMap.get(parts.join('::'));
        if (!v) return;
        const delta = (v.price - basePrice) / 100;
        input.dataset.optionDelta = delta.toFixed(2);
        const pill = input.closest('.caixa-option-pill');
        const span = pill && pill.querySelector('.caixa-option-pill__delta');
        if (span) {
          if (delta === 0)    span.textContent = '+R$ 0';
          else if (delta > 0) span.textContent = '+R$ '  + delta.toFixed(2).replace('.', ',');
          else                span.textContent = '−R$ ' + Math.abs(delta).toFixed(2).replace('.', ',');
        }
      });
    }

    // Select the correct Shopify variant and update visible price
    function selectMatchingVariant() {
      if (!variantMap.size) return;
      const persInput  = pdp.querySelector('input[name="properties[Personalização]"]:checked');
      const patchInput = pdp.querySelector('input[name="properties[Patches]"]:checked');
      const eraInput   = pdp.querySelector('input[data-option-axis="era"]:checked');
      const persVal    = persInput  ? persInput.value  : null;
      const patchVal   = patchInput ? patchInput.value : null;
      const eraVal     = eraInput   ? eraInput.value   : null;
      const keyParts   = [persVal, patchVal, ...(eraVal ? [eraVal] : [])].filter(Boolean);
      if (!keyParts.length) return;
      const match = variantMap.get(keyParts.join('::'));
      if (!match) return;
      const idInput = pdp.querySelector('input[name="id"]');
      if (idInput) idInput.value = match.id;
      const price = match.price / 100;
      const fmt   = (n) => 'R$ ' + n.toFixed(2).replace('.', ',');
      pdp.querySelectorAll('[data-price-total]').forEach((el) => { el.textContent = fmt(price); });
      pdp.querySelectorAll('[data-price-cta]').forEach((el)   => { el.textContent = fmt(price); });
    }

    bindOptionPills(pdp);
    pdp.addEventListener('caixa:recalc', () => selectMatchingVariant());
    const tree = pdp.querySelector('[data-caixa-tree]');
    if (tree) setupCaixaTree(tree, pdp);
    const teamPicker = pdp.querySelector('[data-team-picker]');
    if (teamPicker) setupTeamPicker(teamPicker);
    updatePillDeltasFromVariants();
    selectMatchingVariant();
    if (!variantMap.size) recalcCaixaPrice(pdp); // fallback for pages without variant data
  });


  // ---------- Caixa LP selectable grid (hover = select) ----------
  document.querySelectorAll('[data-caixa-selector]').forEach((grid) => {
    const cards = grid.querySelectorAll('.caixa-grid__card');
    cards.forEach((card) => {
      card.addEventListener('mouseenter', () => {
        cards.forEach((c) => c.classList.toggle('is-selected', c === card));
      });
    });
  });


  // ---------- Buy Now button (caixa PDPs) ----------
  document.querySelectorAll('[data-buy-now]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const form = btn.closest('form[action*="cart/add"]');
      if (!form) return;
      btn.disabled = true;
      const original = btn.textContent;
      btn.textContent = 'Indo pro checkout…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', Accept: 'application/json' },
        body: new URLSearchParams(new FormData(form))
      })
      .then(r => {
        if (!r.ok) throw new Error('add failed');
        window.location.href = '/checkout';
      })
      .catch(() => {
        btn.disabled = false;
        btn.textContent = original;
      });
    });
  });


  // ---------- Caixa Seu Time tree-based team picker ----------
  document.querySelectorAll('[data-team-tree]').forEach((tree) => {
    if (!window.CDM_DB) return;

    // Render leagues as nested accordions (clubs only)
    const leaguesList = tree.querySelector('[data-team-leagues-list]');
    if (leaguesList) {
      leaguesList.innerHTML = window.CDM_DB.leagues.map(lg => `
        <div class="tree-acc__branch" data-branch-id="team-liga-${lg.code}">
          <button type="button" class="tree-acc__trigger tree-acc__trigger--sub" data-acc-toggle="team-liga-${lg.code}" aria-expanded="false">
            <span class="tree-acc__caret">▶</span>
            <span class="tree-acc__label">
              <span class="tree-acc__label-text">${lg.name}</span>
              <span class="tree-acc__country">${lg.country}</span>
            </span>
            <span class="tree-acc__counter" data-team-league-status="${lg.code}"></span>
          </button>
          <div class="tree-acc__panel" data-acc-panel="team-liga-${lg.code}">
            <div class="tree-region__items">
              ${lg.teams.slice().sort().map(t => `<label class="tree-item tree-item--single">
                <input type="radio" name="cdm-team-radio" value="${t}" data-team-label="${t}" data-team-league="${lg.code}">
                <span>${t}</span>
              </label>`).join('')}
            </div>
          </div>
        </div>
      `).join('');
    }

    // Re-init accordion handlers on the new content
    const accRoot = tree.querySelector('[data-acc-root]');
    if (accRoot) setupAccordion(accRoot);

    // Radio selection handler
    const teamInput = tree.querySelector('[data-team-input]');
    const pickedBox = tree.querySelector('[data-team-picked]');
    const pickedName = tree.querySelector('[data-team-picked-name]');
    const clearBtn = tree.querySelector('[data-team-clear]');

    tree.addEventListener('change', (e) => {
      if (e.target.matches('input[type="radio"][data-team-label]')) {
        const label = e.target.dataset.teamLabel;
        if (teamInput) teamInput.value = label;
        if (pickedName) pickedName.textContent = label;
        if (pickedBox) pickedBox.hidden = false;
        // Update branch status counters
        tree.querySelectorAll('[data-team-branch-status]').forEach((el) => el.textContent = '');
        tree.querySelectorAll('[data-team-league-status]').forEach((el) => el.textContent = '');
        const leagueCode = e.target.dataset.teamLeague;
        if (leagueCode) {
          const status = tree.querySelector(`[data-team-league-status="${leagueCode}"]`);
          if (status) status.textContent = '— ' + label;
          const branchStatus = tree.querySelector('[data-team-branch-status="ligas"]');
          if (branchStatus) branchStatus.textContent = '— ' + label;
        } else {
          const branchStatus = tree.querySelector('[data-team-branch-status="selecoes"]');
          if (branchStatus) branchStatus.textContent = '— ' + label;
        }
      }
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        tree.querySelectorAll('input[type="radio"][data-team-label]').forEach((r) => r.checked = false);
        if (teamInput) teamInput.value = '';
        if (pickedBox) pickedBox.hidden = true;
        tree.querySelectorAll('[data-team-branch-status]').forEach((el) => el.textContent = '');
        tree.querySelectorAll('[data-team-league-status]').forEach((el) => el.textContent = '');
      });
    }
  });


  // ---------- Scroll-aware sticky CTA bars ----------
  // Watches the "natural" CTA element. When it leaves the viewport, show the sticky bar.
  function setupStickyCTA(stickyEl, naturalEl) {
    if (!stickyEl || !naturalEl) return;
    stickyEl.removeAttribute('hidden');
    if (!('IntersectionObserver' in window)) {
      stickyEl.classList.add('is-visible');
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // Show sticky when natural is NOT visible in viewport
        const naturalVisible = entry.isIntersecting;
        stickyEl.classList.toggle('is-visible', !naturalVisible);
      });
    }, { threshold: 0, rootMargin: '0px 0px 0px 0px' });
    io.observe(naturalEl);
    // Initial check
    const r = naturalEl.getBoundingClientRect();
    const inView = r.top < window.innerHeight && r.bottom > 0;
    stickyEl.classList.toggle('is-visible', !inView);
  }

  // PDPs: stick the bottom CTA buttons
  document.querySelectorAll('[data-sticky-buy]').forEach((sticky) => {
    const pdp = sticky.closest('[data-caixa-pdp]');
    if (!pdp) return;
    const natural = pdp.querySelector('[data-cta-row="bottom"]');
    setupStickyCTA(sticky, natural);
  });

  // Caixa Misteriosa LP: stick the hero CTA
  document.querySelectorAll('[data-sticky-hero-cta]').forEach((sticky) => {
    const natural = document.querySelector('[data-hero-cta-natural]');
    if (natural) setupStickyCTA(sticky, natural);
  });

})();

// Search modal
(function () {
  var modal = document.getElementById('search-modal');
  if (!modal) return;
  function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    var inp = modal.querySelector('.search-modal__input');
    if (inp) inp.focus();
  }
  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
  }
  document.querySelectorAll('[data-search-open]').forEach(function (btn) {
    btn.addEventListener('click', openModal);
  });
  document.querySelectorAll('[data-search-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  // ---------- Jersey PDP — variant-correct personalisation ----------
  function initJerseyProduct() {
    var wrap = document.querySelector('[data-jersey-product]');
    if (!wrap) return;

    var dataEl = wrap.querySelector('[data-jersey-variants]');
    if (!dataEl) return;

    var variants = JSON.parse(dataEl.textContent);
    var variantMap = Object.create(null);
    variants.forEach(function (v) {
      var key = [v.o1, v.o2, v.o3].filter(Boolean).join('::');
      variantMap[key] = v;
    });

    // sel[axis] = currently selected value for that option position (null = axis not present)
    var sel = { 1: null, 2: null, 3: null };
    [1, 2, 3].forEach(function (axis) {
      var group = wrap.querySelector('[data-jersey-option="' + axis + '"]');
      if (!group) return;
      var active = group.querySelector('.option-pill.is-active');
      if (active) sel[axis] = active.dataset.value;
    });

    function buildKey() {
      return [sel[1], sel[2], sel[3]].filter(Boolean).join('::');
    }

    function fmtMoney(cents) {
      return 'R$ ' + new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format(cents / 100);
    }

    function renderPrice(variant) {
      var priceEl = wrap.querySelector('.pdp__price');
      if (!priceEl) return;
      var html = '';
      if (variant.cap && variant.cap > variant.price) {
        html += '<del style="color:var(--color-text-muted);font-weight:400">' + fmtMoney(variant.cap) + '</del> ';
        html += '<span style="color:var(--color-danger);margin-left:8px">' + fmtMoney(variant.price) + '</span>';
      } else {
        html += fmtMoney(variant.price);
      }
      html += '<span style="font-size:13px;color:var(--color-text-muted);font-weight:400;letter-spacing:0.06em;display:block;margin-top:6px">ou 10× de ' + fmtMoney(Math.round(variant.price / 10)) + ' sem juros</span>';
      priceEl.innerHTML = html;
    }

    function updateVariant() {
      var key = buildKey();
      var match = variantMap[key];
      var idInput = wrap.querySelector('input[name="id"]');
      var addBtn = wrap.querySelector('[data-add-to-cart]');
      if (match) {
        if (idInput) idInput.value = match.id;
        if (addBtn) addBtn.disabled = !match.available;
        renderPrice(match);
      } else {
        // No matching variant — disable add button (misconfiguration safety net)
        if (addBtn) addBtn.disabled = true;
      }
    }

    function updatePersSubfields(value) {
      wrap.querySelectorAll('[data-pers-sub]').forEach(function (el) {
        var isMatch = el.dataset.persSub === value;
        el.style.display = isMatch ? '' : 'none';
        el.querySelectorAll('input, select').forEach(function (inp) {
          inp.disabled = !isMatch;
        });
      });
    }

    [1, 2, 3].forEach(function (axis) {
      var group = wrap.querySelector('[data-jersey-option="' + axis + '"]');
      if (!group) return;
      group.querySelectorAll('.option-pill').forEach(function (pill) {
        pill.addEventListener('click', function () {
          group.querySelectorAll('.option-pill').forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          sel[axis] = pill.dataset.value;
          if (axis === 2) updatePersSubfields(sel[2]);
          updateVariant();
        });
      });
    });

    updateVariant();
  }
  initJerseyProduct();

})();
